import React from 'react';
import { networkQualityService } from '../services/network/network-quality.service';

/**
 * Inizializza NetworkQualityService all'avvio dell'app.
 * Registra listener Capacitor e Navigator API per qualità connessione.
 */
export const NetworkInit: React.FC = () => {
  React.useEffect(() => {
    networkQualityService.initialize().catch(() => {});
    return () => networkQualityService.destroy();
  }, []);
  return null;
};
